const IconShieldCheckBlue = ({
  width,
  height,
}: {
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 20'
      fill='none'
    >
      <path
        d='M15.5578 3.56952C15.8262 3.70001 15.998 3.97647 16 4.28095V8.45657C15.9524 12.269 14.1911 15.8457 11.2266 18.1494L8.59086 19.7908C8.24396 20.0699 7.75595 20.0699 7.40906 19.7908L4.77328 18.1494C1.80883 15.8457 0.0474317 12.269 -4.57764e-05 8.45657V4.28095C0.00191777 3.97647 0.173753 3.70006 0.442154 3.56952L7.28439 0.168074C7.73641 -0.0558618 8.2635 -0.0558618 8.71547 0.168074L15.5578 3.56952Z'
        fill='#00AFFF'
      />
      <path
        d='M6.54975 13.1112C6.30828 13.1115 6.07671 13.0144 5.90628 12.8414L4.41654 11.3337C4.06114 10.974 4.06114 10.3908 4.41654 10.0311C4.77194 9.67142 5.34818 9.67142 5.70358 10.0311L6.54975 10.8875L10.3744 7.01664C10.7303 6.66007 11.3039 6.66143 11.6581 7.01987C12.0123 7.37831 12.0137 7.95892 11.6614 8.31914L7.19332 12.8413C7.02279 13.0144 6.79122 13.1115 6.54975 13.1112Z'
        fill='white'
      />
    </svg>
  )
}

export default IconShieldCheckBlue
